import { groupForecasterModule } from '@groupForecaster/module';
import { priceOptimizerModule } from '@priceOptimizer/module';
import { menuEngineeringModule } from '@menuEngineering/module';
import * as actions from './actions';
import { state } from './models';
import { getters } from './getters';
import { mutations } from './mutations';

export const optimizerModule = {
  actions,
  state,
  getters,
  mutations,
  modules: {
    priceOptimizer: priceOptimizerModule,
    groupForecaster: groupForecasterModule,
    menuEngineering: menuEngineeringModule,
  },
};
